/**
 * Pending-open handshake for feedback deep links (?open=<token>&feedback=1).
 *
 * The brand shell parses the params once and stores the target here; the
 * owning surface consumes it when it mounts/matches: dropdowns open
 * themselves for their token prefixes (design:, editorial:, tactic:,
 * template:, analytics:), FeedbackButtons whose entity token matches
 * exactly open their panel and scroll into view. Tokens mirror
 * feedback_link_path on the backend.
 */

export interface PendingOpen {
  token: string;
  feedback: boolean;
}

export const OPEN_SURFACE_EVENT = 'tend-open-surface';

let pending: PendingOpen | null = null;

export function setPendingOpen(token: string, feedback: boolean): void {
  pending = { token, feedback };
  window.dispatchEvent(new CustomEvent(OPEN_SURFACE_EVENT, { detail: pending }));
}

export function peekPendingToken(): string | null {
  return pending?.token ?? null;
}

/** Exact-match consume — returns the entry (and clears it) or null. */
export function consumePendingOpen(token: string): PendingOpen | null {
  if (pending && pending.token === token) {
    const hit = pending;
    pending = null;
    return hit;
  }
  return null;
}

/** Token for a feedback entity — mirrors the backend link builder. */
export function feedbackOpenToken(entityType: string, entityKey: string): string {
  const prefix: Record<string, string> = {
    channel_queue: 'queue',
    overlay_template: 'template',
    tactic: 'tactic',
    analytics_channel: 'analytics',
    design_section: 'design',
    editorial_section: 'editorial',
  };
  return `${prefix[entityType] ?? entityType}:${entityKey}`;
}
